import { render, staticRenderFns } from "./app-user-add.vue?vue&type=template&id=1276af82&scoped=true&"
import script from "./app-user-add.vue?vue&type=script&lang=js&"
export * from "./app-user-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1276af82",
  null
  
)

export default component.exports